import { render, staticRenderFns } from "./OnboardingQuestionEditMultiple.vue?vue&type=template&id=37225999&"
import script from "./OnboardingQuestionEditMultiple.vue?vue&type=script&lang=js&"
export * from "./OnboardingQuestionEditMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports